import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { NgxSessionService } from './session.service';

export const ngxSessionServiceModule = angular.module('ngxSessionServiceModule', [])
	.factory('ngxSessionService', downgradeInjectable(NgxSessionService) as any)
	.name;
